import Type from "@/model/types/Type";

const type = {
    AFTER_STEP_COMPLETION: "after_step",
    AFTER_EXPEDITION_INSERTED: "expedition_inserted",
}

const list = [
    {
        value: type.AFTER_STEP_COMPLETION,
        text: "Após conclusão de etapa",
    },
    {
        value: type.AFTER_EXPEDITION_INSERTED,
        text: "Após inserção em uma expedição",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}